/* Usage:
What it does:
Tracks search and autocomplete usage metrics in Library.
Usage:
Loaded in _LayoutContainer.cshtml, but provides a search event used in CatalogShared.js.
*/

import Roblox from 'Roblox';
import { logAutocompleteUsage, clearAutocompleteUsage, getAutocompleteMetrics } from './libs/trackSearchMetrics.js';
import { sendMarketplaceLibrarySearchEvent } from './services/sendSearchMetrics.js';

Roblox.LibraryMetrics = {
    logAutocompleteUsage,
    clearAutocompleteUsage,
    getAutocompleteMetrics,
    sendMarketplaceLibrarySearchEvent
}